module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAATVJREFUeAHt2G0OgjAQRVHcBazWfbgx3Q2+ITQhBqrFfnObjP2h6cw7RJM6DCwEEEAAAQQQQAABBBBAAAEEEEAAAQQQQMAjMM/zpLqrbp6PZX3LZllnmpI2VpNR9VLZeqiKI9gM6yzaltnGJAg6fBvemtkqiqD+2/DLQHqxBxQXwQ5UPVV7qwiCBtkL7+azWeMh2GGqIwBrmhVB/XzhbZ64APad0qFVIBQJ735USiMUDV8aoYrwpRCqCp8bocrwuRCqDp8aoYnwqRCaCh8bocnwsRCaDv8vQhfhzyJ0FT4UocvwgQh2kzxa8W91brhcu5J9u0X2G94hn0Bo/8m78G4PQOgvfABCv+F/QOg/vAfhOuF3EK4X/gMh3t/X7mB2BBBAAAEEEEAAAQQQQAABBBBAAIFjgTfBjRZjNMArPwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/navigation-down@2x.png
// module id = 5hfW
// module chunks = 1